import { FilterDescriptor } from '@progress/kendo-data-query'
import { useAppSelector } from 'store'

import { SelectFilter } from '../SelectFilter'

interface PlatformTypeFilterProps {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}

export const PlatformTypeFilter: React.FC<PlatformTypeFilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const status = useAppSelector((state) => state.tradingAccounts.platformTypes)

  const data = status.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return (
    <SelectFilter
      placeholder='Platform Type'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
      style={{ width: 240 }}
    />
  )
}
